import React from 'react';

const Seniors = (): JSX.Element => {
  return <>Seniors page !</>;
};

export default Seniors;
